<script setup lang="ts">
import type { GoalItem } from './types';

const props = defineProps<{
	goal: GoalItem;
	title: string;
	subtitle: string;
	percentage: number;
	accentColor: string;
	expectedDateFormatted: string;
}>();
</script>

<template>
	<article
		class="bg-white p-4 shadow-sm transition-shadow hover:shadow-md"
	>
		<div class="flex items-start gap-3">
			<span class="material-symbols-outlined text-2xl text-gray-800 shrink-0" aria-hidden="true">
				{{ goal.icon?.trim() || 'flag' }}
			</span>
			<div class="min-w-0 flex-1">
				<p class="text-xs font-semibold uppercase tracking-wide text-gray-900">
					{{ title }}
				</p>
				<p class="mt-0.5 text-sm text-gray-700 line-clamp-2">
					{{ subtitle }}
				</p>
				<p
					v-if="expectedDateFormatted"
					class="mt-1 text-xs text-gray-500"
				>
					Data prevista: {{ expectedDateFormatted }}
				</p>
				<div class="mt-3 flex items-center gap-2">
					<div class="h-2 flex-1 bg-gray-200 overflow-hidden">
						<div
							class="h-full transition-all duration-300"
							:style="{
								width: `${percentage}%`,
								backgroundColor: accentColor,
							}"
						/>
					</div>
					<span class="text-sm font-medium text-gray-900 tabular-nums shrink-0">
						{{ percentage }}%
					</span>
				</div>
			</div>
		</div>
	</article>
</template>
